import { action, observable, computed } from "mobx";
import { post } from "../../services/ajax-calls.service";
class MedicalRecommendationStore {

  @observable specialtyJ_codeInfo = []
  @observable specialtyJ_codeDetails = []
  @observable total_allowed_amount = 0
  @observable cash_pay_data = []
  @observable procedure_count = {}
  @observable rejuvenate_kidney_care = {};
  @observable rejuvenate_kidney_care_list = [];
  @observable count = 0;
  @observable cash_pay_procedure_data = []
  @observable url = "/api/v1/medicalActions/recommendation";
  @observable regenex_orthopedic_list = [];
  @observable regenex_orthopedic = {};


  @computed get tiles() {
    return parseInt(this.count % 100) > 0 ? parseInt(this.count / 100) + 1 : parseInt(this.count / 100);
  }

  @action getRegenexOrthopedic = async (data) => {
    this.regenex_orthopedic = {}
    try {
      let response = await post(
        `${this.url}/getRegenexOrthopedic`,
        data
      );
      this.regenex_orthopedic = response?.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getRegenexOrthopedicList = async (data) => {
    this.regenex_orthopedic_list = {}
    try {
      let response = await post(
        `${this.url}/getRegenexOrthopedicList`,
        data
      );
      this.regenex_orthopedic_list = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getCashPayProceduresCount = async (data) => {
    this.count = 0;
    try {
      let response = await post(
        `${this.url}/getCashPayProceduresCount`,
        data
      );
      this.count = response.data.total_procedures;
      this.tiles =
        this.count % data.limit
          ? parseInt(this.count / data.limit)
          : parseInt(this.count / data.limit) + 1;
    } catch (err) {
      console.log(err);
    }
  }

  @action getRejuvenateKidneyCareRecommendation = async (data) => {
    this.rejuvenate_kidney_care = {};
    try {
      let response = await post(
        `${this.url}/getRejuvenateKidneyCareRecommendation`,
        data
      );
      this.rejuvenate_kidney_care = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action getRejuvenateKidneyCareListRecommendation = async (data) => {
    this.rejuvenate_kidney_care_list = [];
    try {
      let response = await post(
        `${this.url}/getRejuvenateKidneyCareListRecommendation`,
        data
      );
      this.rejuvenate_kidney_care_list = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getSpecialtyJCodeRecommendation = async (data) => {
    this.specialtyJ_codeInfo = [];
    try {
      let response = await post(
        `${this.url}/getSpecialtyJCodeRecommendation`,
        data
      );
      this.specialtyJ_codeInfo = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action getSpecialtyJCodeRecommendationDetails = async (data) => {
    this.specialtyJ_codeDetails = [];
    try {
      let response = await post(
        `${this.url}/getSpecialtyJCodeRecommendationDetails`,
        data
      );
      this.specialtyJ_codeDetails = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action getTotalAllowedAmount = async (data) => {
    this.specialtyJ_codeDetails = [];
    try {
      let response = await post(
        `${this.url}/getTotalAllowedAmount`,
        data
      );
      this.total_allowed_amount = response.data[0].total_allowed;
    } catch (err) {
      console.log(err);
    }
  }
  @action getCashPayRecommendation = async (data) => {
    this.cash_pay_data = [];
    try {
      let response = await post(
        `${this.url}/getCashPayRecommendation`,
        data
      );
      this.cash_pay_data = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }
  @action getCashPayRecommendationDetailScreenProcedures = async (data) => {
    this.cash_pay_procedure_data = [];
    try {
      let response = await post(
        `${this.url}/getCashPayRecommendationDetailScreenProcedures`,
        data
      );
      this.cash_pay_procedure_data = response.data;
    } catch (err) {
      console.log(err);
    }
  }
}

export default MedicalRecommendationStore;